import React, { memo } from 'react';

export const DoorGlazed: React.FC = memo(() => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="28" viewBox="0 0 19 28" fill="none">
    <path
      d="M15.8779 3.47656H17.8541C18.1303 3.47656 18.3541 3.70042 18.3541 3.97656V24.0242C18.3541 24.3003 18.1303 24.5242 17.8541 24.5242H15.8779"
      stroke="#919395"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
    <path
      d="M1 3.64243C1 3.40039 1.17336 3.19311 1.41159 3.15031L12.7925 1.10571C13.0992 1.05062 13.381 1.2863 13.381 1.59783V26.422C13.381 26.7268 13.1106 26.9606 12.8089 26.9167L1.42799 25.2603C1.18225 25.2246 1 25.0139 1 24.7656V3.64243Z"
      fill="#C2E5F4"
      stroke="#21282B"
      strokeWidth="1.25"
    />
    <path d="M10.9248 13.3809L10.9248 14.459" stroke="#21282B" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M1 3.64243C1 3.40039 1.17336 3.19311 1.41159 3.15031L12.7925 1.10571C13.0992 1.05062 13.381 1.2863 13.381 1.59783V26.422C13.381 26.7268 13.1106 26.9606 12.8089 26.9167L1.42799 25.2604C1.18225 25.2246 1 25.0139 1 24.7656V3.64243Z"
      stroke="#21282B"
      strokeWidth="1.25"
    />
    <path d="M4.12988 5.95312L3.47553 6.60705" stroke="#21282B" strokeLinecap="round" />
    <path d="M6.16602 6.8418L4.12978 8.87669" stroke="#21282B" strokeLinecap="round" />
  </svg>
));
